import {useState} from "react";
import {enLangTranslation, uaLangTranslation} from "../../globals/constants";

function ContactForm() {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    const lang = localStorage.getItem('language') || 'en';
    const uaLang = uaLangTranslation;
    const enLang = enLangTranslation;
    const translation = lang === 'en' ? enLang : uaLang;

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    async function handleForm(e) {
        e.preventDefault();

        if (!file) {
            setMessage('Please select a file first.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', e.target.username.value);
        formData.append('email', e.target.email.value);
        formData.append('date', e.target.date.value);
        formData.append('subject', e.target.subject.value);
        formData.append('message', e.target.message.value);
        const data = Object.fromEntries(formData.entries());

        console.log(data); // { username: "your input", ... }

        try {
            const response = await fetch('/send', {
                method: 'POST',
                body: formData,
            });

            // Show the success message in the submit-final div
            const submitFinalDiv = document.querySelector('.submit-final');
            submitFinalDiv.style.display = 'block';

            // Hide the success message after 5 seconds
            setTimeout(() => {
                submitFinalDiv.style.display = 'none';
            }, 5000);

            if (!response.ok) {
                throw new Error('Something went wrong');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            e.target.reset();
        }
    }

    return (
        <>
            <div id="contact" className="section-full twm-contact-one">
                <div className="section-content">
                    <div className="container">
                        {/* CONTACT FORM*/}
                        <div className="contact-one-inner">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="contact-form-outer">
                                        {/* title="" START*/}
                                        <div className="section-head left wt-small-separator-outer">
                                            <h2 className="wt-title">{translation.contactForm.title}</h2>
                                            <p>{translation.contactForm.subtitle}</p>
                                        </div>
                                        {/* title="" END*/}
                                        <form className="cons-contact-form" onSubmit={handleForm}>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input name="username" type="text" required
                                                               className="form-control" placeholder={translation.contactForm.name}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input name="email" type="text" className="form-control"
                                                               required placeholder={translation.contactForm.email}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input name="date" type="text" className="form-control"
                                                               required placeholder={translation.contactForm.date}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input name="subject" type="text" className="form-control"
                                                               required placeholder={translation.contactForm.subject}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <textarea name="message" className="form-control" rows={3}
                                                                  placeholder={translation.contactForm.message} defaultValue={""}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="file-upload" className="custom-file-upload">
                                                            {file ? file.name : translation.contactForm.upload}
                                                        </label>
                                                        <input id="file-upload" type="file" onChange={handleFileChange}/>
                                                        {message && <p>{message}</p>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 submit-final">
                                                    <div className="form-group mb-3">
                                                        <span>The form has been successfully submitted!</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <button type="submit" className="site-button">{translation.contactForm.submit}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactForm;